/*
 * PluginVersionListPage Messages
 *
 * This contains all the text for the PluginVersionListPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.plugin.versions';

export default defineMessages({
  major: {
    id: `${scope}.major`,
    defaultMessage: 'MAJOR UPDATE',
  },
  breadcrumb: {
    id: `${scope}.breadcrumb`,
    defaultMessage: 'Versions',
  },
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Versions Page',
  },
  pageDescription: {
    id: `${scope}.pageDescription`,
    defaultMessage: 'A list of versions',
  },
  listVersionItemActionDelete: {
    id: `${scope}.listVersionItemActionDelete`,
    defaultMessage: 'Delete',
  },
  listVersionItemActionUnpublish: {
    id: `${scope}.listVersionItemActionUnpublish`,
    defaultMessage: 'Unpublish',
  },
});
